import { render, staticRenderFns } from "./Lembaga.vue?vue&type=template&id=5e4bf27d&scoped=true"
import script from "./Lembaga.vue?vue&type=script&lang=js"
export * from "./Lembaga.vue?vue&type=script&lang=js"
import style0 from "./Lembaga.vue?vue&type=style&index=0&id=5e4bf27d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4bf27d",
  null
  
)

export default component.exports